import { memo } from 'react';
import { PanelContent } from '@uniqkey-frontend/shared-app';
import OrganizationEmployeeAuditLogsTable from
  '../../../../components/tables/OrganizationEmployeeAuditLogsTable';
import useOrganizationEmployeeAuditLogsTable from
  '../../../../hooks/tables/useOrganizationEmployeeAuditLogsTable';

interface IOrganizationEmployeeAuditLogsTabProps {
  employeeAccountId: string;
}

const OrganizationEmployeeAuditLogsTab = (props: IOrganizationEmployeeAuditLogsTabProps) => {
  const { employeeAccountId } = props;

  const tableProps = useOrganizationEmployeeAuditLogsTable({
    persistentFilters: { employeeAccountId },
    noDataMessageKey: 'table.noData.default',
  });

  return (
    <PanelContent p={0}>
      <OrganizationEmployeeAuditLogsTable
        {...tableProps}
      />
    </PanelContent>
  );
};

export default memo(OrganizationEmployeeAuditLogsTab);
